import React from "react";

export const Footer = () => {
  return (
      <footer className="dark:bg-gray-800"><p className="dark:text-white p-4 font-novaSquare text-center">Copyright© 2025 BardioTech All rights reserved.</p></footer>
  )
}
